import { loc } from "../../../core/utils"
import { format, parse } from "date-fns"
import * as Locales from "date-fns/locale"
import React from "react"
import { Button, Form } from "react-bootstrap"
import { DayPicker } from "react-day-picker"
import * as FinalForm from "react-final-form"

function EditOrderForm({ orderLocale, dateFromOrder, handleSubmit, selected }) {
  const { change } = FinalForm.useForm()
  const { input } = FinalForm.useField("shippingDate")

  function convertFormValueToReadableDate(value) {
    if (!value) return ""
    const dateParsed = parse(value, "y-MM-dd", new Date())
    return format(dateParsed, "dd/MM/y")
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Control type="text" value={convertFormValueToReadableDate(input.value)} disabled={true} />
      <DayPicker
        locale={Locales[orderLocale]}
        mode="single"
        defaultMonth={selected}
        selected={selected}
        onSelect={(date) => {
          change("shippingDate", format(date, "y-MM-dd"))
        }}
        disabled={[{ before: dateFromOrder }, { after: new Date() }]}
      />
      <Button type="submit">{loc("save")}</Button>
    </Form>
  )
}

export default EditOrderForm
